<template>
    <elecBoardThread></elecBoardThread>
  </template>

  <script>
  import elecBoardThread from "@/components/elecBoard/elecBoardThread";
  export default {
    components: {
      elecBoardThread,
    },
    setup() {},
  };
  </script>

  <style lang="scss"></style>
